import http from "@/http/aisea/axios";
const resource = "/enterprises/crews";

export default {
  index(enterpriseCrewId, startAt, endAt) {
    return http.get(`${resource}/${enterpriseCrewId}/day_off_days`, {
      params: {
        start_at: startAt,
        end_at: endAt,
      },
    });
  },

  create(enterpriseCrewId, date, type) {
    return http.post(`${resource}/${enterpriseCrewId}/day_off_days`, {
      date,
      type,
    });
  },

  update(enterpriseCrewId, enterpriseCrewDayOffDayId, date, type) {
    return http.put(
      `${resource}/${enterpriseCrewId}/day_off_days/${enterpriseCrewDayOffDayId}`,
      {
        date,
        type,
      },
    );
  },

  delete(enterpriseCrewId, enterpriseCrewDayOffDayId) {
    return http.delete(
      `${resource}/${enterpriseCrewId}/day_off_days/${enterpriseCrewDayOffDayId}`,
    );
  },

  // 休日サマリ情報
  book(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/day_off_days/book`, {
      params: payload,
    });
  },

  search(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/day_off_days/search`, {
      params: payload,
    });
  },
};
